import { useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import CampaignInfoPopupView from './CampaignInfoPopupView'

import { useFetch } from 'hooks/useFetch'

import { campaignsApi } from 'api/campaigns-api'
import { Intervals } from 'utils/createIntervalFromString'

const CampaignInfoPopupWrapper = () => {
  const [searchParams] = useSearchParams()
  const { id } = useParams()
  const navigate = useNavigate()

  const [period, setPeriod] = useState<Intervals>('year')

  const changeIntervalHandler = (period: Intervals) => {
    setPeriod(period)
  }

  const { data: campaign, loading } = useFetch({
    getData: () => campaignsApi.getOne(+(id || 0)),
  })

  const { data: statistics } = useFetch({
    getData: () => campaignsApi.getStats(+(id || 0), period),
    deps: [period, id],
  })

  const onCloseModal = () => {
    navigate(`../?${searchParams}`, { replace: true })
  }

  const imagesToSlider = campaign?.audience?.seg_rules?.length
    ? campaign?.audience?.seg_rules
        .map((rule) => rule.seg_rule_creatives.map((item) => item.creative.thumbnail))
        .reduce((k, v) => [...k, ...v], [])
    : []

  return (
    <CampaignInfoPopupView
      campaign={campaign}
      onCloseModal={onCloseModal}
      imagesToSlider={imagesToSlider}
      status={loading}
      changeIntervalHandler={changeIntervalHandler}
      statistics={statistics}
      period={period}
    />
  )
}

export default CampaignInfoPopupWrapper
